import {ValueDefinition} from '@/model/types';

export enum Plans {
  NRSP = 'DV-9#0',
  RSP = 'DV-9#1',
  RIF = 'DV-9#2',
  LIRA = 'DV-9#3',
  LIF = 'DV-9#4',
  TFSA = 'DV-9#8',
  RLIF = 'DV-9#9',
  RLSP = 'DV-9#10',
  FHSA = 'DV-9#11',
}

export const DV_9 = {
  id: 'DV-9',
  description: {
    fr: 'Régimes',
    en: 'Plans',
  },
  type: 'Plans',
  values: [
    {
      id: '0',
      value: {
        fr: 'RENE - Non enregistré',
        en: 'NRSP - Non Registered Plan',
      },
      properties: {},
    },
    {
      id: '1',
      value: {
        fr: 'RER - Régime enregistré d’épargne-retraite',
        en: 'RSP - Registered Retirement Savings Plan',
      },
      properties: {
        spousalLabel: {
          fr: 'RER de conjoint - Régime enregistré d’épargne-retraite',
          en: 'Spousal RSP - Registered Retirement Savings Plan',
        },
      },
    },
    {
      id: '2',
      value: {
        fr: 'FRR - Fonds enregistré de revenu de retraite',
        en: 'RIF - Retirement Income Fund',
      },
      properties: {
        spousalLabel: {
          fr: 'FRR de conjoint - Fonds enregistré de revenu de retraite',
          en: 'Spousal RIF - Retirement Income Fund',
        },
      },
    },
    {
      id: '3',
      value: {
        fr: 'CRI - Compte de retraite immobilisé',
        en: 'LIRA - Locked-In Retirement Account',
      },
      properties: {},
    },
    {
      id: '4',
      value: {
        fr: 'FRV - Fonds de revenu viager',
        en: 'LIF - Life Income Fund',
      },
      properties: {},
    },
    {
      id: '8',
      value: {
        fr: 'CELI - Compte d’épargne libre d’impôt',
        en: 'TFSA - Tax-Free Savings Account',
      },
      properties: {},
    },
    {
      id: '9',
      value: {
        fr: 'FRVR - Fonds de revenu viager restreint',
        en: 'RLIF - Restricted Life Income Fund',
      },
      properties: {},
    },
    {
      id: '10',
      value: {
        fr: 'REIR - Régime enregistré immobilisé restreint',
        en: 'RLSP - Restricted Locked-In Savings Plan',
      },
      properties: {},
    },
    {
      id: '11',
      value: {
        fr: 'CELIAPP - Compte d’épargne libre d’impôt pour l’achat d’une première propriété',
        en: 'FHSA - First Home Savings Account',
      },
      properties: {},
    },
  ],
} as const satisfies ValueDefinition;
